import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute, requireAdmin } from '../route';

const WorkflowAdminPage = lazyRouteComponent(
  () => import('./WorkflowAdminPage'),
  'WorkflowAdminPage',
);

/**
 * Hidden admin-only workflow triage page. Deliberately has NO nav entry —
 * reach it directly at /workflow-admin. Built for incidents like the
 * 2026-08 AP-ingestion fanout OOM: terminate whole run trees (root +
 * abandoned fanout children) and bulk-cancel scheduled snooze reruns.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/workflow-admin',
  staticData: {
    app: {
      access: {
        adminOnly: true,
      },
    },
  },
  component: WorkflowAdminPage,
  loader: () => ({
    crumb: 'Workflow Admin Triage',
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
  },
});
